import { createFileRoute } from "@tanstack/react-router";
import { WaitingRoomPage } from "@/features/conferencing";
import { patientDomainIdFromProfile } from "@/shared/lib/patient-profile";

export const Route = createFileRoute("/_consented/waiting-room/$visitId")({ component: Page });

function Page() {
  const { profile } = Route.useRouteContext();
  const { visitId } = Route.useParams();
  // Keyed by the visit: a different one is a different session, and a remount
  // is the honest way to get one.
  return <WaitingRoomPage key={visitId} visitId={visitId} patientId={patientDomainIdFromProfile(profile)} />;
}
